import { ColorSwatch, type ColorToken, Section } from "./section";

const COLOR_TOKENS: ColorToken[] = [
	{ name: "Primary", variable: "--primary", fg: "--primary-foreground" },
	{ name: "Secondary", variable: "--secondary", fg: "--secondary-foreground" },
	{ name: "Accent", variable: "--accent", fg: "--accent-foreground" },
	{ name: "Destructive", variable: "--destructive" },
	{ name: "Muted", variable: "--muted", fg: "--muted-foreground" },
	{ name: "Background", variable: "--background", fg: "--foreground" },
	{ name: "Card", variable: "--card", fg: "--card-foreground" },
	{ name: "Border", variable: "--border" },
	{ name: "Input", variable: "--input" },
	{ name: "Ring", variable: "--ring" },
];

const SIDEBAR_TOKENS: ColorToken[] = [
	{ name: "Sidebar", variable: "--sidebar", fg: "--sidebar-foreground" },
	{
		name: "Sidebar Primary",
		variable: "--sidebar-primary",
		fg: "--sidebar-primary-foreground",
	},
	{
		name: "Sidebar Accent",
		variable: "--sidebar-accent",
		fg: "--sidebar-accent-foreground",
	},
	{ name: "Sidebar Hover", variable: "--sidebar-hover" },
	{ name: "Sidebar Border", variable: "--sidebar-border" },
];

const CHART_TOKENS: ColorToken[] = [
	{ name: "Chart 1", variable: "--chart-1" },
	{ name: "Chart 2", variable: "--chart-2" },
	{ name: "Chart 3", variable: "--chart-3" },
	{ name: "Chart 4", variable: "--chart-4" },
	{ name: "Chart 5", variable: "--chart-5" },
];

export function ColorsSection() {
	return (
		<>
			<Section title="Kolory — tokeny bazowe">
				<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
					{COLOR_TOKENS.map((token) => (
						<ColorSwatch key={token.variable} token={token} />
					))}
				</div>
			</Section>

			<Section title="Kolory — sidebar">
				<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
					{SIDEBAR_TOKENS.map((token) => (
						<ColorSwatch key={token.variable} token={token} />
					))}
				</div>
			</Section>

			<Section title="Kolory — wykresy">
				<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
					{CHART_TOKENS.map((token) => (
						<ColorSwatch key={token.variable} token={token} />
					))}
				</div>
			</Section>
		</>
	);
}
